import { useTenantHostCache } from '@/features/tenant-config/hooks/useTenantByHost';
import env from '@/config/env';

export function useTenantName(): string {
  const data = useTenantHostCache();
  const configured = data?.branding?.['branding.productName']?.trim() ?? '';
  return configured.length > 0 ? configured : env.APP_NAME;
}
